import { Button, Col } from 'antd';
import classNames from 'classnames';
import { Flex } from '../../common';

type RatingType = 'positive' | 'negative';

interface ReasonItemProps {
  desc: string;
  positiveId: number;
  negativeId: number;
  checkedIds: number[];
  onClick: (reasonId: number, type: RatingType) => void;
}

const ReasonItem = ({ desc, positiveId, negativeId, checkedIds, onClick }: ReasonItemProps) => {
  const isPositiveSelected = checkedIds.includes(positiveId);
  const isNegativeSelected = checkedIds.includes(negativeId);

  const containerClasses = classNames(
    'border border-solid border-gray-300',
    'justify-between',
    'py-2 px-2 rounded-md text-xs lg:text-sm select-none',
    'bg-white font-bold',
  );

  const handlePositiveClick = () => {
    if (isPositiveSelected) {
      // Deselect positive
      onClick(positiveId, 'positive');
    } else {
      // Remove negative if selected
      if (isNegativeSelected) {
        onClick(negativeId, 'negative');
      }
      // Select positive
      onClick(positiveId, 'positive');
    }
  };

  const handleNegativeClick = () => {
    if (isNegativeSelected) {
      // Deselect negative
      onClick(negativeId, 'negative');
    } else {
      // Remove positive if selected
      if (isPositiveSelected) {
        onClick(positiveId, 'positive');
      }
      // Select negative
      onClick(negativeId, 'negative');
    }
  };

  return (
    <Col span={24}>
      <Flex className={containerClasses} align="center">
        <span>{desc}</span>
        <Flex gap={2}>
          <Button
            type={isPositiveSelected ? 'primary' : 'default'}
            onClick={handlePositiveClick}
            className={classNames(
              '!px-4 !py-1 !rounded-lg !text-sm font-normal',
              isPositiveSelected ? '!bg-nurture !border-nurture' : '!text-gray-600'
            )}
          >
            مطلوب
          </Button>
          <Button
            type={isNegativeSelected ? 'primary' : 'default'}
            onClick={handleNegativeClick}
            className={classNames(
              '!px-4 !py-1 !rounded-lg !text-sm font-normal',
              isNegativeSelected ? '!bg-red-500 !border-red-500' : '!text-gray-600'
            )}
          >
            نامطلوب
          </Button>
        </Flex>
      </Flex>
    </Col>
  );
};

export default ReasonItem;
